import httpHandler from "../../../utils/httpHandler";
import * as actionTypes from "../constants/actionTypes";

export function list(args) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            httpHandler
                .post("/api/apiAccessKey/list", args)
                .then((response) => {
                    resolve(response);
                    dispatch({type: actionTypes.API_ACCESS_TOKEN_LIST, payload: response.data});
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };
}

export function save(obj, callback) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            httpHandler
                .post("/api/apiAccessKey/save", obj)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };
}

export function clear() {
    return (dispatch) => {
        dispatch({type: actionTypes.API_ACCESS_TOKEN_CLEAR});
    };
}

export function remove(id, callback) {
    return (dispatch) => {
        httpHandler
            .post("/api/apiAccessKey/delete", {id: id})
            .then((response) => {
                callback();
            })
            .catch((error) => {
                callback();
            });
    };
}
